import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { SectionsNodeModel } from '../../models';
import { PanelSwitch } from '../../../custom_shared/components';
import { LayoutRendererProps } from '../../componentTypes';
import { SubmissionScopeSelect } from '../../components';
import SectionRenderer from './SectionRenderer';
import './SectionsLayoutRenderer.less';

interface Props extends LayoutRendererProps {
    node: SectionsNodeModel;
}

const SectionsLayoutRenderer: React.FC<Props> = (props: Props) => {
    const { node, formKey, form, onValuesChange, getComponentRows } = props;

    const containerRef = React.useRef<HTMLDivElement>(null);

    const sectionRefs = React.useRef<Map<string, React.RefObject<HTMLDivElement>>>(new Map());

    const addSectionRef = React.useCallback((sectionId: string, sectionRef: React.RefObject<HTMLDivElement>) => {
        sectionRefs.current.set(sectionId, sectionRef);
    }, []);

    return (
        <>
            <div className="sections-layout-renderer-header-container">
                <PanelSwitch
                    panelsRefs={sectionRefs}
                    containerRef={containerRef}
                    options={node.sections.map(section => ({ id: section.id, label: section.name }))}
                />
                <SubmissionScopeSelect
                    submissionScope={node.submissionScope}
                    setSubmissionScope={submissionScope => node.setSubmissionScope(submissionScope)}
                    mainSectionLabel="For the entire contract"
                    tooltipText="Please specify if instalment terms cover the entire contract or are defined for each section separately."
                />
            </div>

            <div ref={containerRef} className="sections-layout-renderer-container custom-scroll">
                <Form id={node.id} key={formKey} form={form} onValuesChange={onValuesChange}>
                    <div className="sections-layout-content">
                        {node.sections.map(section => (
                            <SectionRenderer
                                key={section.id}
                                node={node}
                                section={section}
                                getComponentRows={getComponentRows}
                                addSectionRef={addSectionRef}
                            />
                        ))}
                    </div>
                </Form>
            </div>
        </>
    );
};

export default observer(SectionsLayoutRenderer);
